import { render, staticRenderFns } from "./XhStrucUserCell.vue?vue&type=template&id=5c7887dc&scoped=true"
import script from "./XhStrucUserCell.vue?vue&type=script&lang=js"
export * from "./XhStrucUserCell.vue?vue&type=script&lang=js"
import style0 from "./XhStrucUserCell.vue?vue&type=style&index=0&id=5c7887dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7887dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7887dc')) {
      api.createRecord('5c7887dc', component.options)
    } else {
      api.reload('5c7887dc', component.options)
    }
    module.hot.accept("./XhStrucUserCell.vue?vue&type=template&id=5c7887dc&scoped=true", function () {
      api.rerender('5c7887dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhStrucUserCell.vue"
export default component.exports